import React, {FC} from "react"
import {DefaultTheme, withTheme} from "styled-components"
import Flex from "@irati/ui/src/Flex"

import id from "@irati/utils/id"
import {getDealTileImage} from "@irati/utils/images"

import {
  BirthdayBoxMetadata
} from "@irati/types"

import {CardImage, StyledFlex} from "./styled"

import CardBody from "./CardBody"

interface Props {
  metadata: BirthdayBoxMetadata,
  id?: string,
  theme: DefaultTheme
}

const BirthdayBoxCard: FC<Props> = ({metadata, theme, ...props}) => {
  return (
    <StyledFlex
      direction="column"
      padding={`0px 0px ${theme.spacing.two} 0px`}
      margin={`0px 0px ${theme.spacing.two} 0px`}>
      <Flex margin={`0px 0px ${theme.spacing.two} 0px`}>
        <CardImage
          id={id("img-banner", props)}
          src={getDealTileImage(metadata.image)} />
      </Flex>
      <CardBody
        id={id("card-body", props)}
        title={metadata.title}
        brandName={metadata.brandName}
        desc={metadata.desc} />
    </StyledFlex>
  )
}

export default withTheme(BirthdayBoxCard)
